import HomeScreen from './Pages/HomeScreen';
import './App.css';

function App() {
  return (
    <div>
      <HomeScreen />
    </div>
  );
}

export default App;